module.exports = __webpack_public_path__ + "img/lnr-bubble.f122b43e.svg";